export default __webpack_public_path__ + "static/media/shield.a3672867.svg";